import { c as _c } from "react/compiler-runtime";
import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from '@/utils/cn';

/**
 * NumberedAvatar — the 32px muted circle with a centered number (Figma "Home" node 1:23 cards).
 * Pure fs-* tokens: round pill, fs-muted fill, fs-text body-md number.
 */
export function NumberedAvatar(t0) {
  const $ = _c(10);
  let className;
  let n;
  let props;
  if ($[0] !== t0) {
    ({
      n,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = n;
    $[3] = props;
  } else {
    className = $[1];
    n = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = cn("flex h-8 w-8 items-center justify-center rounded-fs-pill bg-fs-muted font-medium text-fs-body-md text-fs-text", className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== n || $[7] !== props || $[8] !== t1) {
    t2 = <span className={t1} {...props}>{n}</span>;
    $[6] = n;
    $[7] = props;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
}